import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ModalProps {
  categories?: string;
  infoList?: [];
  termsAndCondition?: any;
  bulletImage?: any;
  cardThumbnail?: any;
  thumbnail?: any;
  description?: any;
  channelSet?: any;
  productPrice?: number;
  discountedPrice?: number;
  priceFrequencyType?: string;
  lozengeBackgroundImage?: any;
  lozengeText?: string;
  title?: string;
  legalLine?: any;
  uploadDataSpeed?: any;
  downloadDataSpeed?: any;
  tvSpeedImage?: any;
  sysId?: string;
  isPreview?: boolean;
  termsAndConditionsCaption?: any;
  analyticsContext?: string;
  productInfo?: unknown[];
  infoTitle?: string;
}
interface DiscoveryDialogContentProps {
  data: ModalProps | null;
  type: string;
  reset: () => void;
  isOpen: boolean;
  setModalContent: (data: ModalProps | null, isOpen: boolean, type: string) => void;
  setIsOpen: () => void;
}

// Create the Zustand store with persistence
export const useDiscoveryDialogContent = create<DiscoveryDialogContentProps>()(
  persist(
    (set, get) => ({
      type: '',
      isOpen: false,
      data: null,

      setIsOpen: () => {
        const value = get().isOpen;
        set({ isOpen: !value });
      },
      reset: () => {
        set({
          isOpen: false,
          data: null,
        });
      },

      setModalContent: (data: ModalProps | null, isOpen: boolean, type: string) => {
        set({
          data: data,
          isOpen,
          type,
        });
      },
    }),
    {
      name: 'discovery-dialog-bottom',
    }
  )
);
